import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './DashboardHome.html?raw';
import on from 'dojo/on';
import Button from '../../moreCore/UI/Button/Button';
import CheckBox from '../../moreCore/UI/CheckBox/CheckBox';
import "../../moreCore/UI/Button/Button";
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/GenericDialog/GenericDialog";
import GridStack from 'gridstack/dist/gridstack-all';
import DashboardWidgetSelector from '../Dashboard/WidgetSelector/WidgetSelector';
import DashboardWidgetSettingsForm from '../Dashboard/WidgetSettingsForm/WidgetSettingsForm';
import DashboardSettingsForm from '../Dashboard/DashboardSettingsForm/DashboardSettingsForm';
//import { require } from "dojo/_base/config";

import { DashboardTypes } from "./DashboardTypes";
import { ToasterHelpers } from "../../more/Helpers";

class DashboardHome extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private txtDashboardDescription: HTMLElement;
    private txtDashboardHeading: HTMLElement;
    private gridstackContainer: HTMLElement;

    private btnSelectWidget: MdsLax<InstanceType<typeof Button>>;
    private btnDashboardSettings: MdsLax<InstanceType<typeof Button>>;

    private Grid: GridStack.GridStack;
    private dashboardData: DashboardTypes.Dashboard;
    private cbEditMode: MdsLax<InstanceType<typeof CheckBox>>;
    private gridWidgetCounter: number = 0;


    loadDashboard() {
        // Dashboard + WidgetList from API
        let data = {

        };

        this.StandbyStart();
        this.RequestManager.callfunction(
            "Webtool_API_Dashboard__LoadDashboard",
            data,
            lang.hitch(this, this._onLoadDashboardEntityResponse),
            lang.hitch(this, this._onLoadDashboardEntityError),
            false // sync
        );
    }

    openWidgetSettings(widget: DashboardTypes.WidgetAssignment) {
        let dlg = new GenericDialog();
        let form = new DashboardWidgetSettingsForm();
        let title = widget.ref_web_dashboard_widget?.name;

        //dlg.addButton("save", "Speichern", lang.hitch(form, form.saveSettings, form.widget), null, "accentBG", "fas fa-save", true);

        //on(form, "saveWidget", lang.hitch(this, this._updateWidgetUserSettings));
        on(form, "dirty", lang.hitch(this, this._onDirtySettings, dlg));
        on(form, "saved", lang.hitch(this, this._onWidgetSettingsSaved, dlg));
        form.setData(widget);

        //dlg.setUserdefinedButton("Speichern", "fas fa-save", lang.hitch(form, form.saveWidget, form.widget), true);
        dlg.show(form, title, null, null, "saveclose", lang.hitch(this, this._onWidgetSettingsDlg, dlg, form));
        dlg.keepOpen = true;

    }
    private _onWidgetSettingsDlg(dlg: MdsLax<InstanceType<typeof GenericDialog>>, form: MdsLax<InstanceType<typeof DashboardWidgetSettingsForm>>, result: number) {
        if (result > 0) {
            dlg.disableAllButtons();
            form.saveSettings();
        }
    }
    private _onWidgetSettingsSaved(dlg: MdsLax<InstanceType<typeof GenericDialog>>) {
        dlg.close(-1, true);
    }
    refreshWidget(widget: DashboardTypes.GridStackWidget) {
        let node = widget.containerNode;
        if (!node) {
            node = document.getElementById(widget.nodeId);
            widget.containerNode = node;
            //ansonsten duplizieren sich die widgets und wir haben tote widgets auf dem dashboard dass wir nicht loeschen koennen
        }

        if (!node) return;
        //this.UiModder.domConstruct.empty(node);

        this.StandbyStart(node);

        this.RequestManager.callfunction(
            "Webtool_API_Dashboard__LoadWidgetData",
            {
                widgetID: widget.ID
            },
            lang.hitch(this, this._onRefreshDashboardWidgetResponse, widget),
            lang.hitch(this, this._onRefreshDashboardWidgetError)
        );
    }

    private _onRefreshDashboardWidgetResponse(widget: DashboardTypes.GridStackWidget, response) {
        this.StandbyStop();
        this._AddWidgets([response], widget.containerNode);
    }

    private _onRefreshDashboardWidgetError(err: more.requestErrorMessage) {
        this.StandbyStop();
        alert(err.Message);
    }


    private _addGrid(dashboardData: DashboardTypes.Dashboard) {
        let opts = this._createObjectFromJson(dashboardData.json_config);
        opts["name"] = dashboardData.name;
        this.Grid = (GridStack as any).addGrid(this.gridstackContainer, opts);

        let gridElement = this.Grid.el as HTMLElement;


        if (dashboardData.coloration?.BackColor?.IsNull != true) {
            let hex = dashboardData.coloration.BackColor.Hex;
            if (hex) {
                let isDark = this.isDarkColor(hex, 80);

                this.UiModder.domClass.add(gridElement, "coloredGridContainer");

                this.UiModder.domClass.toggle(gridElement, "darkTheme", isDark);
                //this.UiModder.domStyle.set(gridElement, "background", hex);
                gridElement.style.setProperty("--bgColor", hex);
            }
        }


        this.Grid.on("change", lang.hitch(this, this._onGridChange));
        this._AddWidgets(dashboardData.widgets);

        // per default kein move/resize
        this.Grid.disable();


        if (dashboardData.name) {
            this.txtDashboardHeading.innerHTML = dashboardData.name;
            this.setTitles(dashboardData.name);
        } else {
            this.txtDashboardHeading.innerHTML = this.translate("WebDashboard_MainTitle");
            this.setTitles(this.translate("WebDashboard_MainTitle"));
        }
    }

    private _createObjectFromJson<T>(json: string): T {
        let ret = {};
        if (!!json) {
            let config = JSON.parse(json);
            for (let key in config) {
                ret[key] = config[key];
            }
        }
        return ret as T;
    }

    private _AddWidgets(assignments: Array<DashboardTypes.WidgetAssignment>, existingNode: HTMLElement = null) {
        for (let assignment of assignments) {
            let gridStackWidget: DashboardTypes.GridStackWidget = {
                ...assignment,
                content: null,
                coordinates: null,
                containerNode: null,
                nodeId: null,
                h: null,
                w: null,
                x: null,
                y: null,
                gridstackContainerElement: null,
                ref_web_dashboard: this.dashboardData
            }

            let widgetUserSettings = this._createObjectFromJson<DashboardTypes.WidgetUserSettings>(assignment.json_usersettings);
            let widgetContainerId = 'gridContainer_' + this.id + '_' + this.gridWidgetCounter;


            let coordinates: DashboardTypes.GridStackCoordinates = null;
            coordinates = this._createObjectFromJson<DashboardTypes.GridStackCoordinates>(assignment.json_config);

            gridStackWidget.coordinates = coordinates;

            let btnRemoveWidget = new Button();
            btnRemoveWidget.setIconRight("fas fa-times");
            btnRemoveWidget.setClasses("hoverDark deleteBtn");
            this.UiModder.domStyle.set(btnRemoveWidget.domNode, "float", "right");

            //let btnSettings = new Button();
            //btnSettings.setIconRight("fas fa-cog");
            //btnSettings.onClick = lang.hitch(this, this.openWidgetSettings, assignment);
            //btnSettings.setClasses("hoverDark settingsBtn");
            //this.UiModder.domStyle.set(btnSettings.domNode, "float", "right");

            let btnRefresh = new Button();
            btnRefresh.setIconRight("fas fa-sync-alt");
            btnRefresh.setClasses("hoverDark reloadBtn");
            this.UiModder.domStyle.set(btnRefresh.domNode, "float", "right");

            let containerNode: HTMLElement = null;

            if (!existingNode) {
                this._createWidgetNodes(gridStackWidget, widgetContainerId);
                containerNode = gridStackWidget.containerNode;
            } else {
                widgetContainerId = existingNode.id;
                containerNode = existingNode;// document.getElementById(widgetContainerId);
                this.UiModder.domConstruct.empty(existingNode);
            }

            gridStackWidget.ID = assignment.ID;

            if (!containerNode) continue;

            this.gridWidgetCounter++;


            gridStackWidget.nodeId = widgetContainerId;

            this.UiModder.domClass.add(containerNode, "widgetContainer");

            let topBar = this.UiModder.domConstruct.create("div", {
                className: "topContainer"
            }, containerNode);
            let contentNode = this.UiModder.domConstruct.create("div", {
                className: "contentContainer"
            }, containerNode);

            let titleContainer = this.UiModder.domConstruct.create("div", {
                className: "titleContainer",
                innerHTML: assignment.ref_web_dashboard_widget?.description
             }, topBar);
             let actionsContainer = this.UiModder.domConstruct.create("div", {
                 className: "actionsContainer"
             }, topBar);

            if (widgetUserSettings.color) {
                this.UiModder.domStyle.set(containerNode.parentElement, "background", widgetUserSettings.color);
            }

            btnRemoveWidget.placeAt(actionsContainer);
            //btnSettings.placeAt(actionsContainer);
            btnRefresh.placeAt(actionsContainer);

            btnRemoveWidget.onClick = lang.hitch(this, this.removeWidget, gridStackWidget);
            btnRefresh.onClick = lang.hitch(this, this.refreshWidget, gridStackWidget);

            switch (assignment.ref_web_dashboard_widget.type) {
                case "html_static":
                case "html":
                    let widgetTemplate = this.UiModder.domConstruct.create("div", {
                        class: "staticHTML",
                        innerHTML: assignment.template
                    }, contentNode);
                    break;
                case "widget": //existing Widget
                    try {
                        window.require([gridStackWidget.ref_web_dashboard_widget.widget_path], lang.hitch(this, function (contentNode, widgetName) {
                            let widget = new widgetName();

                            // setTitles unschädlich machen!
                            if (widget.setTitles) {
                                widget.setTitles = function (param, param2, param3) {
                                    return;
                                }
                            }

                            if (widget.applyDashboardWidgetParams) {
                                widget.applyDashboardWidgetParams(this._createObjectByJson(assignment.json_usersettings));
                            }
                            widget.placeAt(contentNode);

                            if (widget.startup) widget.startup();
                        }, contentNode))
                    } catch (ex) {
                        alert("cannot fetch widget " + gridStackWidget.ref_web_dashboard_widget.widget_path + "\r\n" + ex)
                    }
                    break;
                default:
                    return;
            }
        }
    }

    private _createWidgetNodes(widget: DashboardTypes.GridStackWidget, nodeId: string) {
        let container = document.getElementById(nodeId);

        if (!container) {
            widget.content = this.UiModder.domConstruct.create("div", { id: nodeId }).outerHTML;
            let data = { ...widget.coordinates, content: widget.content, ID: widget.ID };
            this.Grid.addWidget(data);

            container = document.getElementById(nodeId);
        }
        let gridstackContainer = container.parentNode.parentNode;

        widget.containerNode = container;
        widget.gridstackContainerElement = gridstackContainer as HTMLElement;

        return container;
    }

    private _updateWidgetUserSettings(widget) {
        this._saveWidgets([widget]);
        this.UiModder.domConstruct.empty(document.getElementById(widget.nodeId));

        this._AddWidgets([widget], widget.nodeId);
    }

    private _saveWidgets(widgetList: Array<DashboardTypes.WidgetAssignment>) {

        // Problem: wenn da irgendwo das template als HTML mitkommt, dann wird der Request geblockt wegen Safety
        // also die Daten reduzieren auf die nötigsten Metadaten!
        let smallAssignmentData: Array<DashboardTypes.WidgetUpdateData> = [];
        for (let assignedWidget of widgetList) {

            let smallAssignment: DashboardTypes.WidgetUpdateData = {
                ID: assignedWidget.ID,
                json_config: assignedWidget.json_config,
                json_usersettings: assignedWidget.json_usersettings,
                ref_web_dashboard_widget: {
                    ID: assignedWidget.ref_web_dashboard_widget?.ID,
                }

            };

            smallAssignmentData.push(smallAssignment as any);
        }

        let data = {
                dashboardId: this.dashboardData.ID,
            widgets: smallAssignmentData
        };

        console.debug("_saveWidgets", data, widgetList);

        this.RequestManager.callfunction(
            "Webtool_API_Dashboard__SaveWidgetListJSON",
            data,
            lang.hitch(this, this._onSaveDashboardWidgetListResponse, widgetList),
            lang.hitch(this, this._onSaveDashboardWidgetListError),
            false // commit
        );
    }

    private _onSaveDashboardWidgetListResponse(submittedList: Array<DashboardTypes.GridStackWidget>, response) {
        //new widgets
        let index = 0;
        if (response.newWidgets?.length > 0) {
            for (let widget of submittedList) {
                widget.ID = response.newWidgets[index].entityID;
                index++;
            }
            this._AddWidgets(submittedList as any);

            this.StandbyStop();

            this.showToast(this.translate("WebDashboard_Message_NewWidgetsSaved"), ToasterHelpers.ToasterIcons.confirmCheck);
            return;
        }

        this.showToast(this.translate("General_SavingSuccessful"), ToasterHelpers.ToasterIcons.confirmCheck);
    }

    private _onSaveDashboardWidgetListError(err: more.requestErrorMessage) {
        this.StandbyStop();

        alert("saving widgets failed: " + err.Message);
    }


    private _onGridChange(evt, widgets: Array<DashboardTypes.GridStackWidget>) {
        let widgetList: Array<Partial<DashboardTypes.WidgetAssignment>> = [];

        if (widgets) {
            for (let widget of widgets) {
                switch (evt.type) {
                    case "change": //Resized, moved, etc
                        let coords: DashboardTypes.GridStackCoordinates = {
                            h: widget.h,
                            minH: widget.minH,
                            minW: widget.minW,
                            w: widget.w,
                            x: widget.x,
                            y: widget.y,
                        };

                        let simpleWidgetData: Partial<DashboardTypes.WidgetAssignment> = {

                            ID: widget.ID,
                            json_config: JSON.stringify(coords),
                        }
                        widgetList.push(simpleWidgetData);
                        break;
                }
            }
            if (widgetList.length > 0) {
                if (this.cbEditMode.getValue() == true) { // nur im edit-modus. sonst wird auch bei resize-windows dieses event ausgelöst
                    this._saveWidgets(widgetList as any);
                }
            }
        }
    }

    private _onAddWidgetClick() {
        let dlg = new GenericDialog();
        let selector = new DashboardWidgetSelector();

        //on(selector, "addWidget", lang.hitch(this, this._saveWidgets));
        on(selector, "change", lang.hitch(this, this._onSelectedWidget, selector, dlg));

        //dlg.addButton("save", "Speichern", lang.hitch(selector, selector.addWidget, selector.selectedWidgets), null, "accentBG", "fas fa-plus", true)
        //dlg.setUserdefinedButton("Widget hinzufügen", "fas fa-plus", lang.hitch(selector, selector.addWidget, selector.selectedWidgets), true);

        dlg.show('', "Widgets auswählen", null, null, "okcancel", lang.hitch(this, this._onSelectNewWidgetDlg, selector));
        dlg.addNodeToContent(selector.domNode, "first");

        dlg.disableButton("ok");
    }

    private _onSelectNewWidgetDlg(selector: MdsLax<InstanceType<typeof DashboardWidgetSelector>>, result: number) {
        if (result <= 0) return;

        let widgets = selector.getSelectedWidgets();

        // daraus eine "Zuordnung" generieren mit den Daten die wir haben
        let pseudoAssignments: Array<DashboardTypes.WidgetAssignment> = [];
        for (let widget of widgets) {
            let assignment: Partial<DashboardTypes.WidgetAssignment> = {
                ID: null,
                json_usersettings: widget.json_preconfig,
                json_config: null,
                ref_web_dashboard_widget: widget,
                template: widget.template
            }

            pseudoAssignments.push(assignment as any);
        }

        this.StandbyStart();
        this._saveWidgets(pseudoAssignments);
    }

    private _onSelectedWidget(selector: MdsLax<InstanceType<typeof DashboardWidgetSelector>>, dlg: MdsLax<InstanceType<typeof GenericDialog>>) {
        let widgets = selector.getSelectedWidgets();

        dlg.enableButton("ok", !!widgets.length);
    }

    private _onDashboardSettingsClick() {
        let dlg = new GenericDialog();
        let form = new DashboardSettingsForm();

        on(form, "saved", lang.hitch(this, this._onDashboardSettingsSaved, dlg));
        on(form, "dirty", lang.hitch(this, this._onDirtySettings, dlg));

        dlg.keepOpen = true;
        dlg.closeOnEscape = true;

        //dlg.addButton("save", "Speichern", lang.hitch(form, form.saveDashboard, form.dashboard), null, "accentBG", "fas fa-plus", true);

        //dlg.setUserdefinedButton("Speichern", "fas fa-plus", lang.hitch(form, form.saveDashboard, form.dashboard), true);
        //dlg.enableContentOverflow(true);
        dlg.show(form, this.dashboardData.name, null, null, "saveclose", lang.hitch(this, this._onDashBoardSettingsDlg, dlg, form));

        form._setValues(this.dashboardData);
    }
    private _onDashBoardSettingsDlg(dlg: MdsLax<InstanceType<typeof GenericDialog>>, form: MdsLax<InstanceType<typeof DashboardSettingsForm>>, result: number) {
        if (result > 0) {
            dlg.disableAllButtons();
            form.saveDashboard();
        } else {
            dlg.close(-1, true);
        }
    }
    private _onChange_CbEditMode(): void {
        let value = this.cbEditMode.getValue();

        this.UiModder.domClass.toggle(this.domNode, "editMode", value);

        if (value) {
            this.Grid.enable();
        } else {
            this.Grid.disable();
        }
    }

    private _onDirtySettings(dlg: MdsLax<InstanceType<typeof GenericDialog>>, isDirty: boolean) {
        dlg.disableAllButtons(false);
        dlg.enableButton("save", isDirty);
    }

    private _updateDashboard(dashboard) {
        this.Grid.destroy();
        this._addGrid(dashboard);
    }

    private _onDashboardSettingsSaved(dlg: MdsLax<InstanceType<typeof GenericDialog>>) {
        dlg.close(-1, true);

        this._updateDashboard(this.dashboardData);
    }

    private _onSaveDashboarEntityResponse(dashboard) {
        this._updateDashboard(dashboard);
        this.StandbyStop();
    }

    private _onSaveDashboardEntityError(err: more.requestErrorMessage) {
        alert("ERROR beim SaveDashboardWidgets: " + err.Message);
    }


    removeWidget(widget: DashboardTypes.GridStackWidget) {
        //delete widget from dashboard + save dashboard (API)
        let node = widget.gridstackContainerElement;

        if (node) {
            this.Grid.removeWidget(node);
        }

        this.RequestManager.callfunction(
            "Webtool_API_Dashboard__RemoveWidgetFromDashboard",
            {
                widgetID: widget.ID
            },
            lang.hitch(this, this._onDeleteDashboardWidgetResponse, widget),
            lang.hitch(this, this._onDeleteDashboardWidgetError),
            false // sync
        );
    }
    private _onDeleteDashboardWidgetResponse(widgetAssignment: DashboardTypes.WidgetAssignment, response) {
        this.showToast(this.stringFormat(this.translate("WebDashboard_Message_WidgetRemoved"),
            widgetAssignment.ref_web_dashboard_widget.description,
            widgetAssignment.ref_web_dashboard.description), ToasterHelpers.ToasterIcons.confirmCheck);
    }

    private _onDeleteDashboardWidgetError(err: more.requestErrorMessage) {
        alert("removeWidget: " + err.Message);
    }



    private _onLoadDashboardEntityResponse(response: DashboardTypes.Dashboard) {
        this.dashboardData = response;
        this._addGrid(this.dashboardData);
        this.StandbyStop();
    }

    private _onLoadDashboardEntityError(err: more.requestErrorMessage) {
        alert("ERROR beim LoadDashboard: " + err.Message);
    }

    //private _getWidgetConfig(widget: DashboardTypes.GridStackWidget): DashboardTypes.WidgetConfig {
    //    //TODO moveable, sizeable, htmlTemplateString, color?
    //    debugger;
    //    let ret = {
    //        ID: widget.ID,
    //        name: widget.name,
    //        config: {
    //            h: widget.h,
    //            minH: widget.minH,
    //            minW: widget.minW,
    //            w: widget.w,
    //            x: widget.x,
    //            y: widget.y
    //        }
    //    }
    //    return ret;
    //}

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
        this.loadDashboard();
    }
}

export default mdsWidget(DashboardHome);
